/**
 * The widths of the list view's right-hand columns, shared by the header and the rows so a
 * heading always stands over the values it names. Tailwind reads whole class names, so these
 * stay literal.
 */
export const REEL_SESSION_COLUMNS = {
  status: 'w-36',
  created: 'w-40',
  owner: 'w-44',
  /** The cover and delete buttons: no header, just the width they occupy. */
  actions: 'w-18',
} as const;
